import React, { useEffect, useMemo, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar
} from "../../../../../_metronic/_partials/controls";
import { useNotificationUIContext } from "./NotificationUIContext";
import { NotificationFilter } from "./notification-table/notification-filter/NotificationFilter";
import NotificationCreate from "./notification-create/NotificationCreate";
import {
  fetchNotifications,
  createNotification,
  updateNotification
} from "../../_redux/notification/notificationAction";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import NotificationTable from "./notification-table/NotificationTable";
import LoadingAnimation from "./loading-animation/LoadingAnimation";
import { ConfirmationModal } from "../../../Donation/pages/confirmation/confirmation-edit/confirmation-edit-form/ConfirmationModal";
import { toast } from "react-toastify";
import { toastOption } from "../../../../../_metronic/_helpers";
import moment from "moment";
import { RoleChecker } from "../../../../RoleChecker";

export const NotificationCard = ({
  match: {
    params: { id }
  },
  history
}) => {
  // * DECLARE HOOKS
  const dispatch = useDispatch();
  const [openModal, setOpenModal] = useState({
    notification: false,
    confirmation: false
  });
  const initialValue = {
    is_all_organization: true,
    type: "INFO",
    expired_date: moment()
      .utc()
      .format("YYYY-MM-DDTHH:mm")
  };
  const [currentItem, setCurrentItem] = useState(initialValue);

  // * Notification UI Context
  const notificationUIContext = useNotificationUIContext();
  const notificationUIProps = useMemo(() => {
    return {
      queryParams: notificationUIContext.queryParams,
      setQueryParams: notificationUIContext.setQueryParams,
      openEditNotificationPage: notificationUIContext.openEditNotificationPage,
      openNotificationFilePage: notificationUIContext.openNotificationFilePage
    };
  }, [notificationUIContext]);

  // * Getting curret state of notification list from store (Redux)
  const { totalCount, entities, listLoading, actionsLoading } = useSelector(
    state => state.superAdminNotification,
    shallowEqual
  );

  useEffect(() => {
    // * Requset ke Notification Action
    dispatch(fetchNotifications(notificationUIProps.queryParams));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notificationUIProps.queryParams, dispatch]);

  const onSubmitNotification = value => {
    let organizationUuids;

    if (!value.uuid) {
      if (value.organization_uuids)
        organizationUuids = value.organization_uuids.map(item => item.value);
      dispatch(
        createNotification({ ...value, organization_uuids: organizationUuids })
      )
        .then(res => {
          dispatch(fetchNotifications(notificationUIProps.queryParams));
          toast.success(res.data.message, toastOption);
          setOpenModal(prev => ({ ...prev, notification: false }));
          setCurrentItem({});
        })
        .catch(err => {
          toast.error(err.message);
        });
    } else {
      dispatch(
        updateNotification({ ...value, organization_uuids: organizationUuids })
      )
        .then(res => {
          dispatch(fetchNotifications(notificationUIProps.queryParams));
          toast.success(res.data.message, toastOption);
          setOpenModal(prev => ({ ...prev, notification: false }));
          setCurrentItem({});
        })
        .catch(err => {
          toast.error(err.message);
        });
    }
  };

  const onClickDisable = () => {
    dispatch(
      updateNotification({
        ...currentItem,
        is_active: !currentItem.is_active
      })
    )
      .then(res => {
        dispatch(fetchNotifications(notificationUIProps.queryParams));
        toast.success(res.data.message, toastOption);
        setOpenModal(prev => ({ ...prev, confirmation: false }));
        setCurrentItem(initialValue);
      })
      .catch(err => {
        toast.error(err.message);
      });
  };

  const allowCreate = RoleChecker("Create", "notification_organization");
  const allowEdit = RoleChecker("Edit", "notification_organization");

  return (
    <>
      <LoadingAnimation open={actionsLoading} />
      {/* CREATE NOTIF MODAL */}
      <NotificationCreate
        show={openModal.notification}
        onHide={() => {
          setOpenModal(prev => ({ ...prev, notification: false }));
          setCurrentItem(initialValue);
        }}
        onSubmit={onSubmitNotification}
        defaultValues={currentItem}
      />
      {/* CONFIRMATION MODAL */}
      <ConfirmationModal
        show={openModal.confirmation}
        onHide={() => setOpenModal(prev => ({ ...prev, confirmation: false }))}
        modalTitle={`${
          currentItem.is_active ? "Non Aktifkan" : "Aktifkan"
        } notifikasi?`}
        modalTitleContent={`Apakah anda yakin ingin ${
          currentItem.is_active ? "Non Aktifkan" : "Aktifkan"
        } notifikasi${currentItem.is_active ? "" : ", Expired Date akan disetting hari ini dengan penambahan 5 menit dari waktu pengaktifan "}?`}
        onClick={onClickDisable}
      />
      <Card>
        <CardHeader title="Notification">
          <CardHeaderToolbar>
            {allowCreate && (
              <button
                type="button"
                className="btn mx-1 btn-primary"
                onClick={() =>
                  setOpenModal(prev => ({ ...prev, notification: true }))
                }
              >
                Tambah Notifikasi
              </button>
            )}
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <NotificationFilter />
          <NotificationTable
            totalCount={totalCount}
            listLoading={listLoading}
            entities={entities}
            queryParams={notificationUIProps.queryParams}
            setQueryParams={notificationUIProps.setQueryParams}
            openEditNotificationPage={
              notificationUIProps.openEditNotificationPage
            }
            setCurrentItem={setCurrentItem}
            setOpenModal={setOpenModal}
            allowEdit={allowEdit}
          />
        </CardBody>
      </Card>
    </>
  );
};
